// extracted by css-extract-rspack-plugin
export default {"share":"Share-module__share--VaBpp","title":"Share-module__title--XEbcZ","icons":"Share-module__icons--YTFEl","icon":"Share-module__icon--UpyfV"};